<template>
  <div class="col backgroundForm">
  
  <div class="form-row" v-if=" (cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && cDtsUser.roleAssign !== 'FINANCIERO') ">
    <div class="form-group col-12 col-md-4 offset-md-4">
        <label for="nombre_embarcacion">Capitania</label>  
                            <!-- listar las capitanias -->
          <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_location">
            <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option>
          </select>                         
    </div>
    <div class="col-12" align="center">
        <button class="btn btn-info" @click="mSaveNewLocation"><font-awesome-icon icon="sync-alt" /> Actualizar Ubicacion</button>
    </div>

  </div>

  <CargarMapa
    :configMapa="configMapa"
    apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"
  >

    <template slot-scope="{ google, map }">
      <NuevoMarcador
        ref="newMark"
        :marker=cNewLocation[0]
        :google="google"
        :map="map"
      />
    </template>

  </CargarMapa>
  
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');

  import modalLoading from '../modal/modalLoading';

  import CargarMapa from "./LoadMap";
  import Marcadores from "./MarksMaps";
  import NuevoMarcador from './NewMarkMap';

  import { configMapa } from "@/constants/configMapa";
  export default {
    components: {
      CargarMapa,
      Marcadores,
      NuevoMarcador
    },
    mounted(){
      this.callCaptains();
    },
    data() {
      return {
        
        send_dispatch:true,
        renderComponent:false,
        ports:[],
        captain_location:{
          id:0,
          name_port:null
        }
      };
    },
    methods:{
      mValidateNewLocation(){
        if(this.captain_location.id===0){
          toastr.error('Seleccione una Capitania', 'Error');
          return false;
        }
        return true;
      },
      async mSaveNewLocation(){
            // validar los datos
            if(this.mValidateNewLocation()){
                // enviar los datos al servidor
                let message = {
                    title: 'Actualizacion Ubicacion',
                    body: `¿Desea Actualizar la Ubicacion de la Capitania ${this.captain_location.name_port}?`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            let pos={
                              lat:this.cNewLocationPosition.lat,
                              lng:this.cNewLocationPosition.lng
                            }
                            let dtsLocation={
                              id:this.captain_location.id,
                              position:JSON.stringify(pos)
                            }

                            console.log(dtsLocation);
                            // this.activeModal(this.id_modal_progress);
                            // this.process_ordop.load=JSON.stringify(this.loads_declare);
                            let u_location_captain=await axios.post(`updateCaptainLocation?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsLocation));
                            setTimeout(()=>{                                
                                if(u_location_captain.data.status){
                                    toastr.success(u_location_captain.data.respuesta);
                                    // detenemos la animacion                                    
                                }
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            // setTimeout(()=>{
                            //     toastr.error('Ha ocurrido un error en el proceso', 'Error O-01')
                            //     this.btn_p_ordop = false;
                            //     this.inactiveModal(this.id_modal_progress);
                            // }, 3000)
                        }
                    }else{
                        console.log('No se guardo la nueva lozalizacion de la capitania')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }            
      },
      async callCaptains(){
        let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
        // console.log(cp);
        this.ports=cp.data;
      },
      activeModal(e){
        $(`#${e}`).modal('show');
      },
      inactiveModal(e){
        $(`#${e}`).modal('hide');
      }
    },
    computed: {
      configMapa() {
        return {
          ...configMapa,
          center: this.mapCenter
        };
      }, 
      cDtsUser(){
        return this.$store.getters.getUserState;
      },     
      cNewLocation(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getLocation'];
      },
      cNewLocationPosition(){
        return this.$store.getters['sGoogleMaps/getLocationPosition'];
      },
      mapCenter() {
        // return this.markers[0].position;
        return this.cNewLocation[0].position;
      },
    }
  };
  
</script>


// WEBPACK FOOTER //
// src/components/maps/NewLocationCaptain.vue